import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutAlignBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM7 15.5V17H17V15.5H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignBottom;
